import React, { useState } from "react";
import { Box, Typography, Button, styled } from "@mui/material";
import { FROSTED_GLASS } from "./styles";
import { COLUMN_HEIGHT } from "../../constants";

interface HeardOfDialogProps {
  onAnswer: (heardOf: boolean) => void;
}

const scale = `calc(${COLUMN_HEIGHT} / 569px)`;

const DialogContainer = styled(Box, {
  label: "HeardOfDialogContainer",
  shouldForwardProp: (prop) => prop !== "dismissed",
})<{ dismissed?: boolean }>(({ dismissed }) => ({
  position: "absolute",
  top: "55%",
  left: 0,
  right: 0,
  ...FROSTED_GLASS,
  paddingTop: `calc(${scale} * 12px)`,
  paddingBottom: `calc(${scale} * 12px)`,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  overflow: "hidden",
  boxShadow: "-40px 40px 80px -8px rgba(145, 158, 171, 0.24)",
  zIndex: 2,
  opacity: dismissed ? 0 : 1,
  pointerEvents: dismissed ? "none" : "auto",
  transition: "opacity 0.3s ease-out",
}));

const Question = styled(Typography, {
  label: "HeardOfQuestion",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontSize: `calc(${scale} * 18px)`,
  fontWeight: 600,
  lineHeight: 1.56,
  color: "#1C252E",
  textAlign: "center",
  width: "100%",
}));

const ButtonRow = styled(Box, {
  label: "HeardOfButtonRow",
})(() => ({
  display: "flex",
  gap: `calc(${scale} * 12px)`,
  alignItems: "center",
  justifyContent: "center",
  padding: `calc(${scale} * 6px) calc(${scale} * 16px)`,
  borderRadius: 16,
  width: "100%",
}));

const ActionButton = styled(Button, {
  label: "HeardOfActionButton",
})(() => ({
  backgroundColor: "#ffffff",
  color: "#1C252E",
  textTransform: "none",
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 700,
  fontSize: `calc(${scale} * 14px)`,
  minWidth: `calc(${scale} * 64px)`,
  height: `calc(${scale} * 36px)`,
  padding: `0 calc(${scale} * 16px)`,
  borderRadius: 8,
  border: "1px solid rgba(145, 158, 171, 0.32)",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
}));

export const HeardOfDialog = ({ onAnswer }: HeardOfDialogProps) => {
  const [dismissed, setDismissed] = useState(false);

  const handleAnswer = (value: boolean) => {
    setDismissed(true);
    onAnswer(value);
  };

  return (
    <DialogContainer dismissed={dismissed}>
      <Question>Have you heard of this career before?</Question>
      <ButtonRow>
        <ActionButton onClick={() => handleAnswer(true)}>Yes</ActionButton>
        <ActionButton onClick={() => handleAnswer(false)}>No</ActionButton>
      </ButtonRow>
    </DialogContainer>
  );
};
